import React from 'react'
import { Message } from 'semantic-ui-react'
import Conditional from './Conditional'

interface IFormSuccessMessages {
  heading?: string
  content?: string
}

const FormSuccessMessages = ({ heading, content }: IFormSuccessMessages) => {
  return (
    <>
      <Conditional if={content && content.length > 0}>
        <Message positive>
          <Conditional if={heading && heading.length > 0}>
            <Message.Header>{heading}</Message.Header>
          </Conditional>
          <Message.Content>{content}</Message.Content>
        </Message>
      </Conditional>
    </>
  )
}

export default FormSuccessMessages
